/**
 * Supabase client configuration.
 *
 * Uses environment-context to determine the correct URL and key based on hostname:
 * - On localhost: uses VITE_SUPABASE_URL/KEY or falls back to default local
 * - On production: uses hardcoded production URL/key
 */
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { getSupabaseUrl, getSupabaseAnonKey } from '@/contexts/environment-context';

/**
 * Creates a Supabase client with the given URL and key.
 */
function createSupabaseClientInstance(url: string, anonKey: string): SupabaseClient<Database> {
  return createClient<Database>(url, anonKey, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    }
  });
}

// Initialize with current environment config
const supabaseUrl = getSupabaseUrl();
const supabaseAnonKey = getSupabaseAnonKey();

/**
 * Default Supabase client export.
 * Import the supabase client like this:
 * import { supabase } from "@/integrations/supabase/client";
 */
export const supabase = createSupabaseClientInstance(supabaseUrl, supabaseAnonKey);
